import { render, staticRenderFns } from "./SettingList.vue?vue&type=template&id=256b8071&scoped=true&"
import script from "./SettingList.vue?vue&type=script&lang=ts&"
export * from "./SettingList.vue?vue&type=script&lang=ts&"
import style0 from "./SettingList.vue?vue&type=style&index=0&id=256b8071&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256b8071",
  null
  
)

export default component.exports